import React, { Component } from 'react';
import '@styles/public/automatedDispensariesDetail.scss';
import { Button } from '@components/shared/Button';
import { ProductShowcase } from '@components/public/shared/ProductShowcase';
import ShowMore from '@components/shared/ShowMore';
import { BreadCrumbs } from '@components/shared/BreadCrumbs';
import { Animation } from '@components/shared/Animation';
import { MetaHelmet } from '@components/public/shared/MetaHelmet';

export class AutomatedDispensariesDetail extends Component {
    static displayName = AutomatedDispensariesDetail.name;

    constructor(props) {
        super(props);
        this.translate = this.props.translate;

        this.products = [
            {
                heading: this.translate("ad_tb_300_heading", true),
                subheading: this.translate("ad_tb_300_subheading", true),
                points: this.translate("ad_tb_300_points"),
                text: this.translate("ad_tb_300_text"),
                download: this.translate("s_ad_tb_300_brochure", true),
                imgMain: "product_tb_300_main.jpg",
                imgVer: "product_tb_300_vertical.jpg",
                imgHor: "product_tb_300_horizontal.jpg",
                showAnimationDone: false,
            },
            {
                heading: this.translate("ad_tb_combi_heading", true),
                subheading: this.translate("ad_tb_combi_subheading", true),
                points: this.translate("ad_tb_combi_points"),
                text: this.translate("ad_tb_combi_text"),
                download: this.translate("s_ad_tb_combi_brochure", true),
                imgMain: "product_tb_combi_main.jpg",
                imgVer: "product_tb_combi_vertical.jpg",
                imgHor: "product_tb_combi_horizontal.jpg"
            },
            {
                heading: this.translate("ad_tb_locker24_heading", true),
                subheading: this.translate("ad_tb_locker24_subheading", true),
                points: this.translate("ad_tb_locker24_points"),
                text: this.translate("ad_tb_locker24_text"),
                download: this.translate("s_ad_tb_locker24_brochure", true),
                imgMain: "product_tb_locker_24_main.jpg",
                imgVer: "product_tb_locker_24_vertical.jpg",
                imgHor: "product_tb_locker_24_horizontal.jpg"
            },
            {
                heading: this.translate("ad_tb_locker14_heading", true),
                subheading: this.translate("ad_tb_locker14_subheading", true),
                points: this.translate("ad_tb_locker14_points"),
                text: this.translate("ad_tb_locker14_text"),
                download: this.translate("s_ad_tb_locker14_brochure", true),
                imgMain: "product_tb_locker_14_main.jpg",
                imgVer: "product_tb_locker_14_vertical.jpg",
                imgHor: "product_tb_locker_14_horizontal.jpg"
            },
            {
                heading: this.translate("ad_tb_drawer_heading", true),
                subheading: this.translate("ad_tb_drawer_subheading", true),
                points: this.translate("ad_tb_drawer_points"),
                text: this.translate("ad_tb_drawer_text"),
                download: this.translate("s_ad_tb_drawer_brochure", true),
                imgMain: "product_tb_drawer_main.jpg",
                imgVer: "product_tb_drawer_vertical.jpg",
                imgHor: "product_tb_drawer_horizontal.jpg"
            },
            {
                heading: this.translate("ad_tb_gloves_heading", true),
                subheading: this.translate("ad_tb_gloves_subheading", true),
                points: this.translate("ad_tb_gloves_points"),
                text: this.translate("ad_tb_gloves_text"),
                download: this.translate("s_ad_tb_gloves_brochure", true),
                imgMain: "product_tb_gloves_main.jpg",
                imgVer: "product_tb_gloves_vertical.jpg",
                imgHor: "product_tb_gloves_horizontal.jpg"
            },
            {
                heading: this.translate("ad_epv_27_heading", true),
                subheading: this.translate("ad_epv_27_subheading", true),
                points: this.translate("ad_epv_27_points"),
                text: this.translate("ad_epv_27_text"),
                download: this.translate("s_ad_epv_27_brochure", true),
                imgMain: "product_epv_27_main.jpg",
                imgVer: "product_epv_27_vertical.jpg",
                imgHor: "product_epv_27_horizontal.jpg"
            }
        ];

        this.breadCrumbPath = [
            { text: this.translate("s_navlink_dispensary"), link: this.props.navLinks.ad.main},
            { text: this.translate("s_navlink_dispensary_sublink"), link: ""},
        ];

        this.downloadBrochureText = this.translate("s_view_brochure");
        this.helmet = {
            title: this.props.translate("s_dispensary_machines", true),
            alternateHreflangs: this.props.urlList.filter(url => url.page === this.props.currentPage),
            locale: this.props.currentLanguage,
            allLocales: this.props.allLanguages
        };
    }
    ;
    componentDidMount() {
        window.scrollTo({ top: 0 });
    }

    render() {
        return (
            <>
                <MetaHelmet tags={this.helmet} />
                <div id='automatedDispensariesDetail' className='containerCustomMainBigger' ref={this.props.navLinks.ad.subLinks.adDetail.ref}>
                    <section className='intro position-relative pb-0 pb-md-4'>
                        <div className='d-flex justify-content-between'>
                            <div className='d-flex flex-column col-12 col-md-7 col-xl-6 mt-3'>
                                <BreadCrumbs
                                    translate={this.props.translate}
                                    navLinks={this.props.navLinks}
                                    HandleLinkClick={this.props.HandleLinkClick}
                                    path={this.breadCrumbPath}
                                />
                                <div className='d-flex flex-column mt-4'>
                                    <div className='d-flex align-items-center logoHeading pt-2'>
                                        <img src='/files/images/tb.png' alt={`Logo ${ this.props.translate("ad_heading", true) }`} className='me-3' />
                                        <h1 className='d-flex align-items-center mb-0'>
                                            {this.props.translate("ad_heading")}
                                        </h1>
                                    </div>
                                    <div className='d-flex flex-column col justify-content-between'>
                                        <div className='d-flex flex-column col mb-2'>
                                            <span className='mb-1'>{this.props.translate("ad_text")}</span>
                                            <ul>
                                                {this.props.translate("ad_points")}
                                            </ul>
                                            <ShowMore text={this.props.translate("ad_text_more")} label={this.props.translate("ad_show_more")} />
                                        </div>
                                        <div className='mt-2'>
                                            <Button iconClass={"fa-regular fa-file-pdf"} text={this.downloadBrochureText} downloadFile={this.props.translate("s_ad_main_brochure", true)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='bgImg d-none d-md-flex col ms-5'>
                                <figure className='w-100 h-100'>
                                    <picture className='h-100'>
                                        {/* Tablet */}
                                        <source srcSet={`/files/images/automated_dispensaries_detail_panel_tablet.jpg`} media="(max-width: 1200px)" type={`image/jpeg`} />
                                        {/* Pc */}
                                        <source srcSet={`/files/images/automated_dispensaries_detail_panel_pc.jpg`} media="(min-width: 1201px) and (max-width: 1920px)" type={`image/jpeg`} />
                                        {/* Large Pc */}
                                        <source srcSet={`/files/images/automated_dispensaries_detail_panel_pc_large.jpg`} media="(min-width: 1921px)" type={`image/jpeg`} />
                                        {/* Default */}
                                        <img src={`/files/images/automated_dispensaries_detail_panel_pc.jpg`} alt={this.translate("ad_main_image_alt", true)} />
                                    </picture>
                                </figure>
                            </div>
                        </div>
                    </section>
                    <section className='adList mt-5 d-flex flex-column'>
                        <h2 className='d-flex align-items-center mb-4 mb-md-5 blackText'>
                            {this.props.translate("ad_subheading")}
                        </h2>
                        {Object.keys(this.products).map((key, i) => {
                            return <Animation key={i} in={'flyInAnimation up'} out={'flyOutAnimation down'} component={
                                <ProductShowcase first={i === 0} last={this.products.length - 1 === i} product={this.products[key]} key={i} translate={this.props.translate} downloadBrochureText={this.downloadBrochureText} />
                            } />
                        })}
                    </section>
                </div>
            </>
        );
    }
}
